import styled from 'styled-components';

export const FilterStatusLabel = styled.span``;
